<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'derogation.editForm.shortLabel' | translate}}
                <app-tooltip [text]="'derogation.editForm.summary' | translate"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="table-container">
        <aside class="locked">
            <table>
                <thead>
                    <tr>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let derogation of derogations">
                        <tr class="original-label">
                            <td>
                                {{ derogation.text.fullLabel }}
                                <app-tooltip [text]="derogation.text.summary"></app-tooltip>
                            </td>
                        </tr>
                        <tr class="derogation-label">
                            <td>
                                {{ 'derogation.title.shortLabel' | translate }}
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </aside>

        <section class="years-data">
            <table>
                <thead>
                    <tr>
                        <th *ngFor="let year of derogations[0]?.years">{{ year.year }}</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let derogation of derogations">
                        <tr class="original-value">
                            <td *ngFor="let year of derogation.years">
                                <span *ngIf="year.value != null">{{ year.value | formatAmount }}</span>
                            </td>
                        </tr>
                        <tr class="derogation-value">
                            <td *ngFor="let year of derogation.years">
                                <mat-form-field>
                                    <input matInput type="text" [disabled]="!year.isEditable"
                                        [ngModel]="year.userValue | formatAmount: 'rounded': false "
                                        (ngModelChange)="year.userValue = parseValue($event)"
                                        onclick="this.select()">
                                    <span matSuffix> €</span>
                                </mat-form-field>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </section>
    </mat-card-content>
    <mat-card-actions>
        <button mat-raised-button color="accent" (click)="onSubmit()" [disabled]="isLoading" *ngIf="!isReadonly">
            <mat-icon aria-label="Save">save</mat-icon>
            {{ 'derogation.submit.shortLabel' | translate }}
        </button>
        <button mat-raised-button color="accent" (click)="onReset()" [disabled]="isLoading" *ngIf="!isReadonly">
            <mat-icon aria-label="Refresh">refresh</mat-icon>
            {{ 'derogation.reset.fullLabel' | translate }}
        </button>
        <mat-spinner *ngIf="isLoading" [diameter]="35" color="accent" ></mat-spinner>
    </mat-card-actions>
</mat-card>
